import React, { useState, useRef, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import ReplayIcon from '@mui/icons-material/Replay';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import ReactPlayer from 'react-player/youtube';

function App() {
  const [open, setOpen] = useState(true);
  const [playing, setPlaying] = useState(true);
  const [volume, setVolume] = useState(0.8);
  const playerRef = useRef(null);

  useEffect(() => {
    // Turn off closed captioning after player is drawn
    const timer = setTimeout(() => {
      const iframe = document.querySelector('iframe');
      if (iframe && iframe.src) {
        const currentSrc = iframe.src;
        if (!currentSrc.includes('cc_load_policy=0')) {
          iframe.src = `${currentSrc}${currentSrc.includes('?') ? '&' : '?'}cc_load_policy=0&rel=0`;
        }
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handlePlay = () => setPlaying(true);
  const handleStop = () => setPlaying(false);
  const handleRewind = () => {
    if (playerRef.current) {
      playerRef.current.seekTo(0);
      setPlaying(true);
    }
  };

  return (
    <div className="app-background">
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          style: { backgroundColor: '#1a1a1a', color: 'white' }
        }}
      >
        <DialogTitle className="dialog-title">
          nTeligence Zeus - Platform for AI Governance, Compliance and Security
        </DialogTitle>
        <DialogContent>
          <Box className="player-wrapper">
            <ReactPlayer
              ref={playerRef}
              url="https://youtu.be/78yzoTQO68I"
              playing={playing}
              volume={volume}
              controls={false}
              width="100%"
              height="100%"
              config={{
                youtube: {
                  playerVars: {
                    cc_load_policy: 0,
                    modestbranding: 1,
                    rel: 0,
                    playsinline: 1,
                    vq: '1080'
                  }
                }
              }}
            />
          </Box>

          <Stack spacing={2} className="controls-stack">
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="contained"
                startIcon={<PlayArrowIcon />}
                onClick={handlePlay}
              >
                Play
              </Button>
              <Button
                variant="contained"
                startIcon={<StopIcon />}
                onClick={handleStop}
              >
                Stop
              </Button>
              <Button
                variant="contained"
                startIcon={<ReplayIcon />}
                onClick={handleRewind}
              >
                Rewind
              </Button>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center">
              <VolumeDownIcon />
              <Slider
                value={volume}
                min={0}
                max={1}
                step={0.01}
                onChange={(_, value) => setVolume(value)}
                aria-label="Volume"
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => `${Math.round(value * 100)}%`}
              />
              <VolumeUpIcon />
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default App;